// extracted by mini-css-extract-plugin
export var actions = "_66-8";
export var arrow = "_66-5";
export var card = "_66-0";
export var cardWrapper = "_66-9";
export var fieldName = "_66-3";
export var newValue = "_66-6";
export var oldValue = "_66-4";
export var orangeGlowFade = "_66-c";
export var productSection = "_66-1";
export var scrollToBottom = "_66-b";
export var scrollToBottomAnchor = "_66-a";
export var scrollToBottomIcon = "_66-d";
export var showAllButton = "_66-7";
export var table = "_66-2";